export class FilterCountValueConverter {
  toView(array, filterString) {
    if (filterString) {
      return array.filter((item) => eval(filterString)).length;
    } else {
      return array.length;
    }
  }
}
